module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBdItalic.ttf?v=4f69f593d89fa581aec948a351e65d61";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBdItalic.ttf
// module id = 686
// module chunks = 0